// extracted by mini-css-extract-plugin
export default {"modal":"FatalPay_modal__tf-ON","title":"FatalPay_title__WGIB2","fatal":"FatalPay_fatal__Et6ZL","float":"FatalPay_float__AgN7o"};